// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
import { Environment } from './environment.interface';
import { Constants } from './version';

export const environment: Environment = {
	version: Constants.version,
	production: false,
	nativeAppLinkHost: 'dev.customers.portal.labs.nova-a.de',
	firebase: {
		apiKey: 'AIzaSyAmPwN-USQJkF9Fs22FhvKSXRI9qKme17A',
		authDomain: 'signin.dev.customers.portal.labs.nova-a.de',
		projectId: 'novaa-portal-customers-dev',
		storageBucket: 'novaa-portal-customers-dev.firebasestorage.com',
		messagingSenderId: '515882659058',
		appId: '1:515882659058:web:667bdb88e381579a7f746b'
	},
	picturesStorageBucket: 'novaa-portal-dev-pictures',
	featureToggles: {},
	// Enable client side logging
	clientLogEnabled: true,
	// Use local emulator for authentication (must be started before)
	useAuthEmulator: false,
	// Use local emulator for database (must be started before)
	useDBEmulator: false,
	// Use local emulator for storage (must be started before)
	useStorageEmulator: false,
	// Use local emulator for functions (must be started before)
	useFunctionsEmulator: false,
	// Use mock data instead of accessing the real database
	useMockData: false,
	// Override system settings to force the theme mode to 'light' or 'dark'
	forceThemeMode: null,
	// Add an extra top padding for the device status bar / notch
	forceStatusbarPadding: false
};
